module.exports = __webpack_public_path__ + "static/img/bcg.7f4688f4.webp";